import React,{ useEffect, useState } from 'react';
import {InfiniteLoader } from 'react-weui';
import { Toast } from 'antd-mobile';
import { getCollectLog } from '@/services/myself';
import { myCollectProgram } from '@/services/program';

import Empty from '@/components/empty';
import { Tabs } from 'antd-mobile';
import { history } from 'umi';
import styles from './styles.scss';


export default (props) => {

  const [page, setPage] = useState(0);
  const tabs = [
    { title: '课程'},
    { title: '栏目'},
  ];


  return (
    <div>

      <Tabs
        tabs={tabs}
        page={page}
        tabBarActiveTextColor={'#333333'}
        tabBarInactiveTextColor={'#888888'}
        tabBarUnderlineStyle={{backgroundColor:'transparent',height:'2'}}
        onChange={(tab, index) => { setPage(index) }}
        onTabClick={(tab, index) => { setPage(index) }}
      >
       <CollectCourse/>
       <CollectProgram/>
      </Tabs>
    </div>
  )
}



const CollectCourse = (props) => {
  const [dataList, setDataList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数

  useEffect(() => {

    getList(1);

  }, []);

  function getList(pageNo,resolve, finish) {
    getCollectLog({pageNo:pageNo, pageSize:20}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (pageNo == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(pageNo);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断

      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }

    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }


  return (
      <InfiniteLoader onLoadMore={ (resolve, finish) => {
              if (dataList.length >= totalCount && totalCount !== 0) {
                finish();
                return;
              }
              getList(pageNo+1,resolve,finish);

            }}>


        {

          dataList.length ? dataList.map(item => (
            <div className={styles.item_box} key={item.id} onClick={() =>{
              history.push('/home/courseDetail?courseId=' + item.courseId + '&title=' + item.course.name);

            }}>
              <img alt='' src={item.course.image} />

              <div className={styles.item_content}>
                <label className={styles.item_title}>{item.course.name}</label>
                <label className={styles.item_subtitle}>{item.courseCategory.name}</label>
              </div>
            </div>
          )) :<Empty text={'暂无数据'}/>
        }
        {dataList.length >= totalCount && totalCount !== 0 && (
          <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
            没有更多数据了
          </div>
        )}
      </InfiniteLoader>
  )
}



const CollectProgram = (props) => {
  const [dataList, setDataList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数

  useEffect(() => {

    getList(1);

  }, []);

  function getList(pageNo,resolve, finish) {
    myCollectProgram({pageNo:pageNo, pageSize:20}).then(res => {
      console.log(res);
      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (pageNo == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(pageNo);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断

      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }

    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }


  return (

      <InfiniteLoader onLoadMore={ (resolve, finish) => {
              if (dataList.length >= totalCount && totalCount !== 0) {
                finish();
                return;
              }
              getList(pageNo+1,resolve,finish);

            }}>


        {

          dataList.length ? dataList.map(item => (
            <div className={styles.item_box} key={item.id} onClick={() =>{
              history.push('/program/programDetail?programId=' + item.columnId + '&title=' + item.column.name);
            }}>
              <img alt='' src={item.column.image} />

              <div className={styles.item_content}>
                <label className={styles.item_title}>{item.column.name}</label>
                <label className={styles.item_subtitle}>{item.columnVideo.videoName}</label>
                <label className={styles.item_subtitle}>{item.columnVideo.dateName}</label>
              </div>
            </div>
          )) :<Empty text={'暂无数据'}/>
        }
        {dataList.length >= totalCount && totalCount !== 0 && (
          <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
            没有更多数据了
          </div>
        )}
      </InfiniteLoader>
  )
}
